import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { createReducer } from 'redux-orm';
import {
  ChatBotReducer,
  ConfigReducer,
  ModalStateReducer,
} from '@dpdgroupuk/cc-chat-fe';

import searchParcels from './searchParcels';
import orm from '../orm/orm';

export default combineReducers({
  form,
  searchParcels,
  orm: createReducer(orm),
  chat: combineReducers({
    config: ConfigReducer,
    chatBot: ChatBotReducer,
    modalState: ModalStateReducer,
  }),
});
